module.exports = __webpack_public_path__ + "static/media/gsb-iconNew-Arrival-copy.daf84c4a.svg";